export default __webpack_public_path__ + "static/media/audit.222e6fe3.svg";